export default "__VITE_ASSET__CFWGTcr$__"